export const Routes = {
  home: "/",
  login: "/login",
  createAccount: "/create-account",
  passwordResetRequest: "/reset-password",
  passwordResetComplete: "/reset-password/complete",
  emailVerify: "/account/verify",
  documentSelection: "/workspace/documents",
  clients: "/workspace/clients",
  clientsExplorer: "/workspace/clients/:clientId?/projects/:projectId?",
  documentCreation: "/workspace/create",
  pageCounter: "/tools/page-counter",
  feedback: "/workspace/feedback",
  statementClassifier: "/tools/statement-classifier",
  sdeWorkbook: "/tools/sde-workbook",
  contextPreviewConsole: "/tools/context-preview",
  listingInferenceReviewPortal: "/listing/inference/review",
  account: "/workspace/account",
  review: "/document/review",
  finalEdits: "/document/final-edits",
  prompt: "/document/prompt",
  refine: "/document/refine",
  documentDetailsPrompt: "/document/details",
  chooseSubscription: "/payment/choose",
  paymentSetup: "/payment/setup",
  demographicSurvey: "/payment/demographic",
  adminUsers: "/workspace/admin/users",
  adminPlan: "/workspace/admin/plan",
  inviteAccept: "/invite/accept",
} as const;
